'use strict';

goog.provide("Ntry.Vim");

Ntry.Vim = function() {
    var that = this;
    this._workspaceScript = {};
    this._view = Ntry.interfaceManager.getDom('ntryPlayground');
    this.createDom();
    Ntry.addEventListener("run", this, this.syncScript);

    //Entry.addEventListener('entryBlocklyMouseUp', this.mouseupBlock);

    this.reference = {
        "this": {
            "move" : 'maze_step_move_step"',
            "jump" : 'maze_step_jump"',
            "left" : 'maze_step_rotate"><field name="VALUE">LEFT</field',
            "right" : 'maze_step_rotate"><field name="VALUE">RIGHT</field'
        },
        "console": 'maze_step_move_step"',
        "variable" : {}
    }
};

(function(p){

    p.createDom = function () {
        var parent = this._view;
        var colTop = Ntry.createElement('div', parent, null, 'ntryRightColTop');
        this._currentBlockNumber = Ntry.createElement('div', colTop, null, 'currentBlockNumber');
        this._goalBlockNumber = Ntry.createElement('div', colTop, null, 'goalBlockNumber');

        this.topbackground = Ntry.createElement('div', colTop, null, 'topbackground');
        var playground = Ntry.createElement('div', parent, null, 'ntryPlayground');

        this.codeMirror = CodeMirror(playground, {
            lineNumbers: true,
            value: "this.move();\nthat.move();\nthis.move();\n",
            mode:  {name:"javascript", globalVars: true},
            theme: "default",
            indentUnit: 4,
            styleActiveLine: true,
            extraKeys: {"Ctrl-Space": "autocomplete"},
            // gutters: ["CodeMirror-lint-markers"],
            lint: true
        });
    };

    p.syncScript = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.SCRIPT_CONTAINER),
            entity = null;
        for (var key in entities) {
            entity = entities[key];
        }

        var scriptComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.SCRIPT_CONTAINER
        );
        var script = scriptComp.script;
        var code = this.codeMirror.getValue();

        Entry.Parser.jsToBlock(code);
        var xml = this.codeToXml(code);
        scriptComp.script = xml;
    };

    p.codeToXml = function(code) {
        var ast = acorn.parse(code);
        var xmlFront = '<xml><block type="maze_step_unstart"><next>',
            xmlBack = "</next></block></xml>";

        var astBody = ast.body;
        return xmlFront + this._codeToXml(astBody) + xmlBack;
    };

    p._codeToXml = function(astNode) {
        var xmlFront = "";
        var xmlBack = "";
        var isError = false;

        for (var i = 0; i < astNode.length; i++) {
            var node = astNode[i];

            if (node.type) {
                try{
                    var xmlSnippet = this._parseStatement(node);
                }
                catch(e) {
                    isError = true;
                    break;
                }
                if (i === 0) {
                    xmlFront += xmlSnippet.front;
                    xmlBack = xmlSnippet.back + xmlBack;
                } else {
                    xmlFront += "<next>" + xmlSnippet.front;
                    xmlBack = "</next>" + xmlSnippet.back + xmlBack;
                }

            } else {
                console.error("그런 일은 있을 수 없어", node.start, node.end);
            };
        };

        if(isError) {
            return '';
        } else {
            return xmlFront + xmlBack;
        }
    };


    p._parseStatement = function(node) {

        try{
            var xmlFront = "";
            var xmlBack = "";
            switch(node.type) {
                case "WhileStatement":
                    console.error("while 문 아직 지원 안함");
                    xmlFront += '<block type="maze_step_for_true_1"><statement name="STACK">';
                    xmlFront += this._codeToXml(node.body.body);
                    xmlFront += '</statement>';
                    xmlBack = '</block>' + xmlBack;

                    break;
                case "ForStatement":
                    console.error("for 문 아직 지원 안함");
                    xmlFront += '<block type="maze_step_for"><field name="VALUE">'+ this.getRepeatCount(node) +'</field><statement name="DO">'
                    xmlFront += this._codeToXml(node.body.body);
                    xmlFront += '</statement>';
                    xmlBack = '</block>' + xmlBack;
                    break;
                case "ExpressionStatement":
                    var extype = node.expression.type;
                    if (extype === "CallExpression") {
                        var callee = node.expression.callee;

                        var blockType;
                        if (callee.type === "MemberExpression") {
                            var calleeObject = callee.object.type === "ThisExpression" ?
                                "this" : callee.object.name;
                            var callProperty = callee.property.name;
                            blockType = this.reference[calleeObject][callProperty];
                        } else {
                            blockType = this.reference[callee.name];
                        }

                        if (blockType) {
                            xmlFront += '<block type="' + blockType + '>';
                            xmlBack = '</block>' + xmlBack;
                        } else {
                            console.error("method not exist", node.start, node.end);
                            throw "method not exist";
                        }
                    } else {
                        console.error("Not supported expression", node.start, node.end);
                        throw "Not supported expression";
                    }
                    break;

                case "VariableDeclaration":
                    this.setVar(node);
                    return;
                    break;
                case "IfStatement":
                    this.ifGenResult(node);
                    break;
                default:
                    console.error("Not supported statement", node.start, node.end);
            }
            return {front: xmlFront, back: xmlBack};

        } catch(e) {
            console.log(e);
            var anotation = this.getLineNumber(node.start, node.end);
            anotation.message = e;
            anotation.severity = "error";
            var a = this.codeMirror.markText(anotation.from, anotation.to, {
              className: "CodeMirror-lint-mark-error",
              __annotation: anotation,
              clearOnEnter: true
            });

            throw e;
        }
    };

    function makeMarker(labels, severity, multiple, tooltips) {
        var marker = document.createElement("div"), inner = marker;
        marker.className = "CodeMirror-lint-marker-" + severity;
        if (multiple) {
          inner = marker.appendChild(document.createElement("div"));
          inner.className = "CodeMirror-lint-marker-multiple";
        }

        if (tooltips != false) CodeMirror.on(inner, "mouseover", function(e) {
          showTooltipFor(e, labels, inner);
        });

        return marker;
    }

    p.getLineNumber = function (start, end) {
        var value = this.codeMirror.getValue();
        var lines = {
            'from' : {},
            'to' : {}
        }

        var startline = value.substring(0, start).split(/\n/gi);
        lines.from.line = startline.length - 1;
        lines.from.ch = startline[startline.length - 1].length;

        var endline = value.substring(0, end).split(/\n/gi);
        lines.to.line = endline.length - 1;
        lines.to.ch = endline[endline.length - 1].length;

        return lines;
    }

    p.setVar = function(node) {
        var ele =node.declarations;

        for(var i=0; i<ele.length; i++) {
            var _ele = ele[i];
            this.reference['variable'][_ele.id.name] = _ele.init.value;
        }
    };

    p.getVar = function(name) {
        return this.reference['variable'][name];
    };

    p.getRepeatCount = function(node) {
        var startVal = node.init.declarations[0].init.value;
        var test = node.test;
        var op = test.operator;
        var endVal = test.right.value;
        var updateOp = node.update.operator;

        var res = 0;
        if(!(updateOp == '++')){
            var temp = startVal;
            var startVal = endVal;
            var endVal = temp;
        }

        switch (op) {
            case '<':
                res = endVal - startVal;
            break;

            case '<=':
                res = ((endVal+1) - startVal);
            break;

            case '>':
                res =  startVal - endVal;
            break;

            case '>=':
                res = ((startVal+ 1) - endVal);
            break;
        }

        if(res < 0 || isNaN(res))
            return 0;
        return res;
    };

    p.update = function() {
        /*
        var entityManager = Ntry.entityManager;
        var entities = entityManager.getEntitiesByComponent(Ntry.STATIC.SCRIPT_CONTAINER);
        var componentTimeStamp;
        if (_.isEmpty(entities)) return;
        else {
            var key = _.first(_.keys(entities));
            var component = entityManager.getComponent(key,
                            Ntry.STATIC.SCRIPT_CONTAINER);
            this._workspaceScript.script = component.script;
            componentTimeStamp = component.timeStamp;
            var workspaceScript = this._workspaceScript;
            if (!workspaceScript.timeStamp ||
                    workspaceScript.timeStamp< componentTimeStamp) {
                workspaceScript.timeStamp = componentTimeStamp;
                this.setWorkspace(this._workspaceScript.script);
            }
        }
        */

    };

    p.loadConfig = function () {
        //this.setBlockMenu(Ntry.configManager.getConfig("availableBlocks"));
    };

    p.setWorkspace = function (xml) {
    };

})(Ntry.Vim.prototype);


